import { __rest } from "tslib";
import { forwardRef, useEffect, useRef } from 'react';
import { createReactWrapper } from '../common/PrefixUtils';
import { handleForwardRef } from '../common/RefUtils';
import { ChangeSyntheticEvent, InputSyntheticEvent } from '../common/SyntheticEvent';
export const Checkbox = forwardRef((_a, ref) => {
    var { children, onChange, onInput, helperText, errorText, checked } = _a, otherProps = __rest(_a, ["children", "onChange", "onInput", "helperText", "errorText", "checked"]);
    const checkboxRef = useRef();
    const handledRef = handleForwardRef(checkboxRef, ref);
    useEffect(() => {
        var _a;
        const handleChange = (event) => onChange === null || onChange === void 0 ? void 0 : onChange(new ChangeSyntheticEvent(event));
        (_a = checkboxRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('change', handleChange);
        return () => {
            var _a;
            (_a = checkboxRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('change', handleChange);
        };
    }, [onChange]);
    useEffect(() => {
        var _a;
        const handleInput = (event) => {
            onInput === null || onInput === void 0 ? void 0 : onInput(new InputSyntheticEvent(event));
        };
        (_a = checkboxRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('input', handleInput);
        return () => {
            var _a;
            (_a = checkboxRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('input', handleInput);
        };
    }, [onInput]);
    return createReactWrapper({
        tagName: 'chameleon-checkbox',
        props: Object.assign(Object.assign({}, otherProps), { 'helper-text': helperText, 'error-text': errorText, 
            /**
             * The current checkedness of the element. This property serves as a mechanism
             * to set the `checked` property through both property assignment and the
             * .setAttribute() method. This is useful for setting the field's checkedness
             * in UI libraries that bind data through the .setAttribute() API
             * and don't support IDL attribute binding.
             */
            'current-checked': checked, ref: handledRef }),
        children,
    });
});
